// Environment variables in Vite are prefixed with VITE_

import { Capacitor } from '@capacitor/core';

// API URLs and endpoints
export const API_URL = import.meta.env.VITE_API_URL;
export const BASE_URL = import.meta.env.VITE_BASE_URL;

// Firebase Configuration
export const FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID;
export const FIREBASE_MESSAGING_SENDER_ID = import.meta.env.VITE_FIREBASE_M_S_ID;
export const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;

// Firebase Emulator Configuration
export const USE_EMULATOR = import.meta.env.VITE_USE_EMULATOR === 'true';
export const FIREBASE_AUTH_EMULATOR_HOST = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
export const FIREBASE_AUTH_EMULATOR_PORT = Number(import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT || 9099);
export const FIREBASE_STORE_EMULATOR_HOST = import.meta.env.VITE_FIREBASE_STORE_EMULATOR_HOST;
export const FIREBASE_STORE_EMULATOR_PORT = Number(import.meta.env.VITE_FIREBASE_STORE_EMULATOR_PORT || 9001);

// Integrations
export const ARRAY_APP_KEY = import.meta.env.VITE_ARRAY_APP_KEY;
export const ARRAY_ENV = import.meta.env.VITE_ARRAY_ENV;
export const GOOGLE_MAP_KEY = import.meta.env.VITE_GOOGLE_MAP_KEY;
export const SEGMENT = import.meta.env.VITE_SEGMENT;
export const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID || 'h8f4u1m3';
export const FB_PIXEL_ID = import.meta.env.VITE_FB_PIXEL;
export const LOG_ROCKET = import.meta.env.VITE_LOG_ROCKET;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENV;
export const PLAID_ENV = import.meta.env.VITE_PLAID_ENV || 'sandbox';
export const ESUSU_PUBLIC_KEY = import.meta.env.VITE_ESUSU_PUBLIC_KEY;
export const LO_TOOL_API_KEY = import.meta.env.VITE_LO_TOOL_API_KEY;
export const STRIPE_FREE_PRICE = import.meta.env.VITE_STRIPE_FREE_PRICE;
export const STRIPE_MONTHLY_PRICE = import.meta.env.VITE_STRIPE_MONTHLY_PRICE;
export const STRIPE_ANNUAL_PRICE = import.meta.env.VITE_STRIPE_ANNUAL_PRICE;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// NMI Configuration
export const NMI_COLLECT_TOKEN_KEY = import.meta.env.VITE_NMI_COLLECT_TOKEN_KEY;

// Environment helpers
export const isDevelopment = () => import.meta.env.MODE === 'development';
export const isProduction = () => import.meta.env.MODE === 'production';
export const isTest = () => import.meta.env.MODE === 'test';

// Custom environment modes
export const isOffline = () => import.meta.env.VITE_NODE_ENV === 'offline';

// Appflow Live Updates kill switch. On by default so normal builds are unaffected;
// the e2e build sets this to 'false'. Without it, useLiveUpdates syncs the channel's
// bundle on launch and reloads into it at the first route change — which would swap
// the code under test out from under an e2e run, silently and with no error.
export const LIVE_UPDATES_ENABLED = import.meta.env.VITE_LIVE_UPDATES_ENABLED !== 'false';

// Helper for checking if in Array sandbox mode
export const isArraySandbox = ARRAY_ENV !== 'production';

// Helper for checking if running in the demo environment
export const isDemo = FIREBASE_PROJECT_ID === 'solve-mdop-staging';

// True ONLY in the real production deployment. Demo/staging is a production
// *build* (MODE === 'production') but points at the solve-mdop-staging Firebase
// project, so it is deliberately NOT treated as production here. Use this (not
// isProduction()) to gate testing affordances that must stay off for real users
// yet remain usable on demo/staging.
export const isProductionEnvironment = () => isProduction() && !isDemo;

// Feature flag: re-enable email sign-in/sign-up on Capacitor iOS only
export const ENABLE_IOS_EMAIL_SIGN_IN = true;

// Email sign-in/sign-up is available in the demo/staging environment, and on
// Capacitor iOS when ENABLE_IOS_EMAIL_SIGN_IN is set.
export const showEmailSignIn = isDemo || (ENABLE_IOS_EMAIL_SIGN_IN && Capacitor.getPlatform() === 'ios');

// Helper for getting proper Array subdomain based on environment
export const getArraySubdomain = () => (isArraySandbox ? 'sandbox.' : '');
